import * as React from 'react';
import { cx } from './cx';

export type CardProps = React.HTMLAttributes<HTMLElement> & {
  as?: 'section' | 'div' | 'article';
  padding?: 'none' | 'md' | 'lg';
};

/** Superfície branca com borda sutil e raio de superfície do design system. */
export const Card = React.forwardRef<HTMLElement, CardProps>(function Card(
  { as: Tag = 'section', padding = 'md', className, ...props },
  ref,
) {
  return (
    <Tag
      ref={ref as React.Ref<HTMLDivElement>}
      className={cx('tae-card', padding === 'md' && 'p-5 sm:p-6', padding === 'lg' && 'p-6 sm:p-8', className)}
      {...props}
    />
  );
});

export function CardTitle({
  children,
  action,
  className,
  as: Tag = 'h2',
}: {
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  as?: 'h2' | 'h3';
}) {
  return (
    <div className={cx('mb-4 flex items-center justify-between gap-3', className)}>
      <Tag className="font-display text-[19px] font-semibold leading-7 text-[var(--taskall-content-primary)]">{children}</Tag>
      {action}
    </div>
  );
}
